// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3ifeF","label":"Radio_label__2J8_h","checkMark":"Radio_checkMark__3HwoG","disabled":"Radio_disabled__15k_N"};